<template>
  <div class="form-page-container">
    <PremiumPage
      title="Create New Album"
      subtitle="Define basic information and cover image for the album"
      showBack
      show-footer-buttons
      submit-label="Submit"
      :loading="loading"
      @cancel="$router.push('/societyadmin/gallery')"
      @submit="saveGalleryDetail"
    >
      <div class="pa-4">
        <v-form>
          <div class="half-width-wrap">
            <v-row justify="center" class="mb-12">
              <v-col cols="12">
                <div class="premium-field-label mb-6">Album Cover Image</div>
                
                <div class="profile-uploader-wrap">
                  <input
                    type="file"
                    @change="changeFile"
                    ref="fileInput"
                    hidden
                    accept="image/*"
                  />
                  
                  <div class="cover-preview shadow-lg" @click="openFileExplorer">
                    <v-img
                      v-if="previewImage"
                      :src="previewImage"
                      class="preview-img"
                      contain
                    />
                    <div v-else class="preview-placeholder">
                      <v-icon size="48" color="#CBD5E1">mdi-image-plus-outline</v-icon>
                      <span class="mt-2">Click to Upload</span>
                    </div>
                    
                    <!-- <div class="edit-badge">
                      <v-icon small color="white">mdi-pencil</v-icon>
                    </div> -->
                  </div>

                  <div class="mt-4 text-tx3 text-caption font-weight-bold uppercase-label" :class="{ 'red--text': serverSideErrors.picture }">
                     {{ serverSideErrors.picture || "Recommended: JPG, PNG (Square)" }}
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12">
                <PremiumInput
                  v-model="gallery.title"
                  label="Album Title *"
                  placeholder="e.g. Society Republic Day 2024"
                  icon="mdi-folder-text-outline"
                  v-validate="'required|max:50'"
                  name="title"
                  :error="errors.first('title') || serverSideErrors.title"
                />
              </v-col>
            </v-row>
          </div>
        </v-form>
      </div>
    </PremiumPage>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import PremiumPage from "../../common/PremiumPage.vue";
import PremiumInput from "../../common/PremiumInput.vue";

export default {
  name: 'AddGallery',
  components: { PremiumPage, PremiumInput },
  data() {
    return {
      loading: false,
      serverSideErrors: {},
      previewImage: null,
      profile_pic: null,
      gallery: {
        title: "",
      },
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    saveGalleryDetail() {
      this.$validator.validateAll().then((result) => {
        if (!result) return;
        this.loading = true;
        let formData = new FormData();
        formData.append("title", this.gallery.title);
        if (this.profile_pic) formData.append("picture", this.profile_pic);

        this.$axios.post("/societyadmin/gallery/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        }).then((response) => {
          this.loading = false;
          if (response.data.status) {
            this.setAlert({ showAlert: true, message: "Album created successfully", variant: "green accent-4", timeout: 2000 });
            this.$router.push({ path: "/societyadmin/gallery" });
          } else {
            this.serverSideErrors = {};
            if (response.data.errors) response.data.errors.forEach(e => { this.serverSideErrors[e.field] = e.message; });
            else this.showErr(response.data.message || "An unexpected error occurred while creating the album.");
          }
        }).catch(() => {
          this.loading = false;
          this.showErr("Failed to connect to the server. Please check your connection and try again.");
        });
      });
    },
    openFileExplorer() { this.$refs.fileInput.click(); },
    changeFile(e) {
      const file = e.target.files[0];
      if (file) {
        this.profile_pic = file;
        const reader = new FileReader();
        reader.onload = (e) => { this.previewImage = e.target.result; };
        reader.readAsDataURL(file);
      }
    },
    showErr(msg) { this.setAlert({ showAlert: true, message: msg, variant: "red accent-3", timeout: 2000 }); },
  },
};
</script>

<style scoped>
.form-page-container {
  padding: 24px;
  width: 100%;
  margin: 0 auto;
}

/* ── 50% width wrapper ── */
.half-width-wrap {
  max-width: 50%;
}
@media (max-width: 960px) {
  .half-width-wrap {
    max-width: 100%;
  }
}

.premium-field-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--tx3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.profile-uploader-wrap { display: flex; flex-direction: column; }

.cover-preview {
  width: 220px; height: 165px;
  background: var(--surface2);
  border: 2px dashed var(--border);
  border-radius: 20px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  display: flex; align-items: center; justify-content: center;
}
.cover-preview:hover { 
  border-color: var(--brand); 
  background: var(--surface3); 
  transform: translateY(-2px); 
}

.preview-img { width: 100%; height: 100%; object-fit: cover; }
.preview-placeholder { display: flex; flex-direction: column; align-items: center; color: var(--tx3); font-size: 13px; font-weight: 600; }

.edit-badge {
  position: absolute; bottom: 12px; right: 12px;
  width: 32px; height: 32px; border-radius: 10px;
  background: var(--brand); display: flex; align-items: center; justify-content: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
  z-index: 2;
}

.uppercase-label { text-transform: uppercase; letter-spacing: 0.05em; font-size: 10px; }

.cancel-btn { color: var(--tx3); font-weight: 600; text-transform: none; }
.save-btn { border-radius: 12px !important; font-weight: 800; height: 46px !important; text-transform: none !important; }
</style>